
    // @ts-nocheck
    // This file is auto generated
    export const iconNames = [
  {
    "name": "ai-assistant",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "ai-assistent": {
        "weight": "light"
      }
    }
  },
  {
    "name": "ai-star",
    "outlineWeights": [],
    "filledWeights": [
      "normal"
    ],
    "legacyNames": {}
  },
  {
    "name": "ampersand",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "ampersand": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "application-bending",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "application-bending": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-cutting",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "application-cutting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-flame-cutting",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "application-flame-cutting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-laser-blanking-coil",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "application-icon-laser-blanking-coil": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-laser-blanking-press",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "application-icon-laser-blanking-press": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-laser-cutting",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "application-laser-cutting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-plasma-cutting",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "application-plasma-cutting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "archive",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "archive": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-down",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "arrow-small-down": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-download",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "download-arrow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "arrow-left",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "arrow-small-left": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-right",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "arrow-small-right": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-rotate-bottom",
    "outlineWeights": [
      "normal",
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "reset": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-rotate-top",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "reload": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "arrow-up",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "arrow-small-up": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "automation",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "automation": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-calculation",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-calculation": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-circle",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-circle-small": {
        "weight": "bold"
      },
      "nav-profile": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "avatar-column",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-culture": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-connectivity",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-connectivity": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-contact",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-contact": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-customer-admin",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-customer-admin": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-customer-multiple",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-customer-multiple": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-customer",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-customer": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-dialog",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-dialog": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-hand-star",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-hand-star": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-hand",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-hand": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-multiple",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-multiple": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-plus",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-plus": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-service",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-service": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-star",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-star": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-technical-service",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-technical-service": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-wrench-list",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "avatar-wrench",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-wrench": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar": {
        "weight": "light"
      }
    }
  },
  {
    "name": "backpack",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "backpack": {
        "weight": "light"
      }
    }
  },
  {
    "name": "badge-5-checkmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "warranty-5-years": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bag",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "bag": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bank",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "financial-bank": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bell-slash",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "no-notification": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bell",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "nav-notification": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "bin",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "delete": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "book",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "nav-success-story": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "bookmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "fav": {
        "weight": "light"
      },
      "fav-filled": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "books",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "books": {
        "weight": "light"
      }
    }
  },
  {
    "name": "box-cog-multiple",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "genuine-parts": {
        "weight": "light"
      }
    }
  },
  {
    "name": "box-open-checkmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "order-status-package-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "box-open",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "box-open": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "box-star",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "box-star": {
        "weight": "light"
      }
    }
  },
  {
    "name": "box",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "box": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bullet-points",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "list": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "calculator",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "financial-calculator": {
        "weight": "light"
      }
    }
  },
  {
    "name": "calendar",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "calendar": {
        "weight": "light"
      }
    }
  },
  {
    "name": "camera-cross",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "camera-denied": {
        "weight": "light"
      }
    }
  },
  {
    "name": "camera",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "camera": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-bending-tools",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "cart-bending-tools": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-checkmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "cart-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-circle-hand",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "shop-order": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-cogs",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "cart-genuine-parts": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-punching-tools",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "cart-punching-tools": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart",
    "outlineWeights": [
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "cart": {
        "weight": "normal"
      },
      "nav-shopping-cart": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "carts",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "intralogistics": {
        "weight": "light"
      }
    }
  },
  {
    "name": "certificate",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "certificate": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-growth",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "financial-grow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "progress-magnifier": {
        "weight": "light"
      },
      "magnifier-chart": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-progress-circle-arrows",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "financial-grow-circle": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-progress-money",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "financial-sales": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-turning-point",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "call-predictive": {
        "weight": "light"
      }
    }
  },
  {
    "name": "checklist-eye",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "checklist-eye": {
        "weight": "light"
      }
    }
  },
  {
    "name": "checkmark-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "checkmark-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "checkmark",
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "checkmark-rounded-thin": {
        "weight": "normal"
      },
      "checkmark": {
        "weight": "bold"
      },
      "checkmark-thin": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chevron-down",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "arrow-down": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-download",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "download": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "chevron-inwards",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "zoom-in": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-left-double",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "arrow-nav-left-double": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-left",
    "outlineWeights": [
      "bold",
      "normal",
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "arrow-big-left": {
        "weight": "light"
      },
      "arrow-left": {
        "weight": "normal"
      },
      "arrow-nav-left": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-outwards",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "zoom-out": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-right-double",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "arrow-nav-right-double": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-right",
    "outlineWeights": [
      "bold",
      "normal",
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "arrow-big-right": {
        "weight": "light"
      },
      "arrow-right": {
        "weight": "normal"
      },
      "arrow-nav-right": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-scroll-down-double",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "chevron-scroll-down-end",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "chevron-scroll-down",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "chevron-up",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "chevron-upload",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "upload": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "circle-bin",
    "outlineWeights": [],
    "filledWeights": [
      "light"
    ],
    "legacyNames": {
      "delete-circle-red": {
        "weight": "light",
        "filled": true
      }
    }
  },
  {
    "name": "circle-chart",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "performance-cockpit": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-checkmark",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [
      "normal"
    ],
    "legacyNames": {
      "circle-checked": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "circle-chevron-right",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "circle-arrow-right": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-cross",
    "outlineWeights": [],
    "filledWeights": [
      "normal"
    ],
    "legacyNames": {
      "circle-filled-cross": {
        "weight": "normal",
        "filled": true
      }
    }
  },
  {
    "name": "circle-eye",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "circle-eye": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-hand",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "circle-hand": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-info",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "info-rounded": {
        "weight": "light"
      },
      "info-circle": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "circle-play",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "play-rounded": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-plus",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "circle-plus": {
        "weight": "light"
      },
      "plus-rounded": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-questionmark",
    "outlineWeights": [
      "bold",
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "circle-questionmark": {
        "weight": "bold"
      },
      "faq": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-slash",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "circle-declined": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "circle-two-arrows",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "circle-two-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-warning",
    "outlineWeights": [],
    "filledWeights": [
      "normal"
    ],
    "legacyNames": {}
  },
  {
    "name": "circle",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "circle-empty": {
        "weight": "normal"
      },
      "circle-filled": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "circles",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "circles": {
        "weight": "light"
      }
    }
  },
  {
    "name": "clipboard-checklist-cog",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "clipboard-checkmark",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "clipboard-checkmark": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "clipboard-list-checkmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "clipboard-list-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "clipboard-list",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "watchlist": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "clipboard-wrench-screwdriver",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "clock-arrow-pen",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "clock-arrow-pen": {
        "weight": "light"
      }
    }
  },
  {
    "name": "clock-arrow",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "clock-arrow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "clock",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "clock": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cog-arrows-circle",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "cog-chart",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "cog-chart": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cog-circles",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "cog-circles": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cog-crossed-document",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "cog-crossed",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "cog-hands",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "cog-hands": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cog-multiple",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "cog-multiple": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cog",
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "nav-settings": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "combs",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "combs": {
        "weight": "light"
      }
    }
  },
  {
    "name": "contact-list",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-contacts": {
        "weight": "light"
      }
    }
  },
  {
    "name": "copy",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "copy": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "crane",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "crane": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cross",
    "outlineWeights": [
      "bold",
      "normal",
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "ux-input-clearable": {
        "weight": "normal"
      },
      "close-thin": {
        "weight": "light"
      },
      "close": {
        "weight": "normal"
      },
      "close-bold": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "cube",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "decision-tree-symbols",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "dialog-secure": {
        "weight": "light"
      }
    }
  },
  {
    "name": "decision-tree",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "dialog-secure": {
        "weight": "light"
      }
    }
  },
  {
    "name": "dialog-circles",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "dialog-lock",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "dialog-secure": {
        "weight": "light"
      }
    }
  },
  {
    "name": "dialog-thumbs",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "dialog-thumbs": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "dialog",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "dialog": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document-checkmark-pen",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "document-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document-code",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "document-dotted",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "draft": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document-invoice-red",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "document-invoice",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "document-list-pen",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "document-list-edit": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document-pen-money",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "financial-quoting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document-star",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "document",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "file-generic": {
        "weight": "light"
      }
    }
  },
  {
    "name": "documents",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "documents": {
        "weight": "light"
      }
    }
  },
  {
    "name": "earth-generic",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "globe": {
        "weight": "light"
      }
    }
  },
  {
    "name": "earth",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "globe-fine": {
        "weight": "light"
      },
      "globe-small": {
        "weight": "bold"
      },
      "nav-globe": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "electrical-circuit",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "free-of-interferences": {
        "weight": "light"
      }
    }
  },
  {
    "name": "ellipsis",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "eye-slash",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "eye-striked": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "factory",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "factory": {
        "weight": "light"
      },
      "nav-industry": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "file-bnc",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "file-bnc": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-dxf",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "file-dxf": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-mp4",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "file-mp4": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-pdf",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "file-pdf": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-scdoc",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "file-scdoc": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-stp",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "file-stp": {
        "weight": "light"
      }
    }
  },
  {
    "name": "filter-horizontal-triple",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "filter-horizontal",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "filter-horizontal": {
        "weight": "light"
      }
    }
  },
  {
    "name": "filter-vertical",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "filter-vertical": {
        "weight": "light"
      }
    }
  },
  {
    "name": "globe-circle-arrows",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "globe-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "globe-coordinates-pin",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "globe-pin": {
        "weight": "light"
      }
    }
  },
  {
    "name": "globe-coordinates",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "globe-coordinates": {
        "weight": "light"
      }
    }
  },
  {
    "name": "graduation-cap-bag",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "graduates-professionals": {
        "weight": "light"
      }
    }
  },
  {
    "name": "graduation-cap",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "graduates": {
        "weight": "light"
      }
    }
  },
  {
    "name": "grid",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "tiles-outline": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "hand-dots-arrow",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "hand-list-arrow",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "hand-plus-right",
    "outlineWeights": [
      "light",
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "hand-plus",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "hand-plus": {
        "weight": "light"
      }
    }
  },
  {
    "name": "handshake-pen-paper",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "service-agreement": {
        "weight": "light"
      }
    }
  },
  {
    "name": "hashtag",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "hashtag": {
        "weight": "light"
      }
    }
  },
  {
    "name": "home",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "nav-home": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "horizon",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "horizon": {
        "weight": "light"
      }
    }
  },
  {
    "name": "hourglass-circle-arrow",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "hourglass-circle-arrow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "jubilee-cake",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "lightbulb-checkmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "lightbulb-approved": {
        "weight": "light"
      }
    }
  },
  {
    "name": "lightbulb-cross",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "lightbulb-denied": {
        "weight": "light"
      }
    }
  },
  {
    "name": "lightbulb",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "lightbulb": {
        "weight": "light"
      }
    }
  },
  {
    "name": "link",
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "live-indicator",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "logo-facebook",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "social-facebook": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "logo-instagram",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "social-instagram": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "logo-kununu",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "social-kununu": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "logo-line",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "social-line": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "logo-linkedin",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "social-linkedin": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "logo-twitter",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "social-twitter": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "logo-wechat",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "social-wechat": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "logo-x",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "social-x": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "logo-xing",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "social-xing": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "logo-youku",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {}
  },
  {
    "name": "logo-youtube",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "social-google-plus": {
        "weight": "bold",
        "filled": true
      },
      "social-youtube": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "machine-bookmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-fav": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-chart-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-progress-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-checkmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-checked": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-circle-arrows",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-factory-wifi",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-factory-connected": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-gauge",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-gauge": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-monitor-controls",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-screen-control": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-monitor",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-desktop": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-plus",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-plus": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-wifi-multiple",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-multiple-connected": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-wifi",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine-connected": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine",
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "machine": {
        "weight": "light"
      }
    }
  },
  {
    "name": "magnifier-cross",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "magnifier-long",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "search": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "magnifier-plus",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "magnifier-plus": {
        "weight": "light"
      }
    }
  },
  {
    "name": "magnifier",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "nav-search": {
        "weight": "bold"
      },
      "search-small": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "mail-arrow-right",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "mail-arrow-right": {
        "weight": "light"
      },
      "mail-arrow-right-green": {
        "weight": "light"
      }
    }
  },
  {
    "name": "mail-checkmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "mail-approved": {
        "weight": "light"
      }
    }
  },
  {
    "name": "mail-cross",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "mail-denied": {
        "weight": "light"
      }
    }
  },
  {
    "name": "mail-open",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "mail-open": {
        "weight": "light"
      }
    }
  },
  {
    "name": "mail",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "mail": {
        "weight": "light"
      },
      "nav-contact": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "manual-tools",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "manual-power-tools": {
        "weight": "light"
      }
    }
  },
  {
    "name": "map-germany-pin",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "germany-pin": {
        "weight": "light"
      }
    }
  },
  {
    "name": "material-bin",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "material-scrap": {
        "weight": "light"
      }
    }
  },
  {
    "name": "material-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "material-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "material",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "material": {
        "weight": "light"
      }
    }
  },
  {
    "name": "menu",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "menu": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "message-unread",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "message-unread": {
        "weight": "light"
      }
    }
  },
  {
    "name": "minus",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "minus": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "moneybag",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "financial-moneybag": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-chart-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "monitoring": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-code",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "programming": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-cross-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "error-analytics": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-documents",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "documents-screen": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-tiles-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "tiles-screen-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-warning-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "warning-screen-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "network-cube",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [
      "normal"
    ],
    "legacyNames": {}
  },
  {
    "name": "newspaper",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "press": {
        "weight": "light"
      }
    }
  },
  {
    "name": "newsroom-magazines",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "newsroom-magazines": {
        "weight": "light"
      }
    }
  },
  {
    "name": "notification-error",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "notification-error": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "notification-information",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "notification-information": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "notification-warning",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "notification-warning": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "octagon-warning",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "warning": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "package-cross",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "package-error": {
        "weight": "light"
      }
    }
  },
  {
    "name": "packages",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "packages": {
        "weight": "light"
      }
    }
  },
  {
    "name": "paper-plane",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "part-bended",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "pause",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "pause": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "pen-wrench",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "theory-and-practice": {
        "weight": "light"
      }
    }
  },
  {
    "name": "pencil-line",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "pencil-line": {
        "weight": "light"
      }
    }
  },
  {
    "name": "pencil-square",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "edit": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "person-arrows",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "avatar-directions": {
        "weight": "light"
      }
    }
  },
  {
    "name": "phone-circle-arrows",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "phone-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "phone-mail",
    "outlineWeights": [
      "normal",
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "phone",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "phone": {
        "weight": "light"
      }
    }
  },
  {
    "name": "play",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "play-filled": {
        "weight": "bold",
        "filled": true
      },
      "play": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "plus",
    "outlineWeights": [
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "plus-small": {
        "weight": "bold"
      },
      "plus": {
        "weight": "normal"
      },
      "plus-bold": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "powder",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "powder": {
        "weight": "light"
      }
    }
  },
  {
    "name": "printer-magnifier",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "print-search": {
        "weight": "light"
      }
    }
  },
  {
    "name": "process-circle-arrows",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "process-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "questionmark-checkmark",
    "outlineWeights": [
      "light",
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "question-mark-approved": {
        "weight": "light"
      }
    }
  },
  {
    "name": "quotation-mark",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "quotation-mark": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "sample-kit",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "sample-kit": {
        "weight": "light"
      }
    }
  },
  {
    "name": "scales",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "scales": {
        "weight": "light"
      }
    }
  },
  {
    "name": "screw-magnifying-glass",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "share-nodes",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "social-share": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "shield-lock",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "shield-lock": {
        "weight": "light"
      }
    }
  },
  {
    "name": "shipping-truck",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "shipping": {
        "weight": "light"
      }
    }
  },
  {
    "name": "shop-devices",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "shop-devices": {
        "weight": "light"
      }
    }
  },
  {
    "name": "showroom",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "showroom": {
        "weight": "light"
      }
    }
  },
  {
    "name": "signpost",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "signpost": {
        "weight": "light"
      }
    }
  },
  {
    "name": "smartphone-apps",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "smartphone-apps": {
        "weight": "light"
      }
    }
  },
  {
    "name": "snowflake",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "snowflake": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-avatar-registration",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "software-avatar-registration": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-code-cog",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "software-code-cog": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-cube-lock",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "software-licensing": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-cube",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "software": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-error-404",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "software-error-404": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-error-500",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "software-error-500": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-gauge",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "software-speed": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-images",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "software-images": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-warning-triangle",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "software-warning": {
        "weight": "light"
      }
    }
  },
  {
    "name": "sort",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "sort": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "square-arrow-in",
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "square-in": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "square-arrow-out",
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "square-out": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "square-info",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "info": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "square",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "square": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "squares-magnifier",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "tiles-big-magnifier": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "squares",
    "outlineWeights": [
      "light",
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "nav-applications": {
        "weight": "normal"
      },
      "tiles-big": {
        "weight": "light"
      }
    }
  },
  {
    "name": "star",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "star": {
        "weight": "normal"
      },
      "star-filled": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "thumbs-down",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "thumbs-right",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "thumbs-up",
    "outlineWeights": [
      "light",
      "normal"
    ],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "like": {
        "weight": "light"
      },
      "like-filled": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "ticket",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "ticket": {
        "weight": "light"
      }
    }
  },
  {
    "name": "tiles",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "tiles": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "timer",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "clock-timer": {
        "weight": "light"
      }
    }
  },
  {
    "name": "toggle-switch",
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "tools-punching-bending",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "tools-punching-bending": {
        "weight": "light"
      }
    }
  },
  {
    "name": "tools-punching-scanner",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "tools-punching-scanner": {
        "weight": "light"
      }
    }
  },
  {
    "name": "tools-punching",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "tools-punching": {
        "weight": "light"
      }
    }
  },
  {
    "name": "tools",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "tools": {
        "weight": "light"
      }
    }
  },
  {
    "name": "triangle-warning-double",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "warning-triangle": {
        "weight": "light"
      }
    }
  },
  {
    "name": "triangle-warning",
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "warning-triangle-simple": {
        "weight": "light"
      }
    }
  },
  {
    "name": "truck-checkmark",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "truck-checkmark-center": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "truck",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "truck": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "trutops-design",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "trutops-orientation",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "trutops-slicing",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "trutops-support-structures",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "whiteboard-avatar",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "training-avatar": {
        "weight": "light"
      }
    }
  },
  {
    "name": "whiteboard",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "training": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-checkmark",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "wrench-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-circle-arrow",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "wrench-circle-arrow": {
        "weight": "light"
      },
      "case-in-progress": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-circle-arrows",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "wrench-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-clock",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "wrench-clock-arrow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-cog",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "wrench-cog": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-crossed-document",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "wrench-crossed",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "wrench-mail-circle-arrow",
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "legacyNames": {
      "wrench-circle-arrow-mail-green": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-plus",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "wrench-plus": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "wrench-screwdriver",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "wrench-simple",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "wrench-simple": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "wrench",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {
      "wrench": {
        "weight": "normal"
      }
    }
  }
]
    